function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from '../utils/create';
import { props } from './props';
import Column from './Column.js'
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('table', {
    staticClass: "table",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('colgroup', [_vm.showIndex ? _c('col', {
    attrs: {
      "name": "index",
      "width": _vm.colWidth
    }
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.columns, function (col) {
    return _c('col', {
      key: col.prop,
      attrs: {
        "name": col.prop,
        "width": col.width
      }
    });
  })], 2), _vm._v(" "), _c('thead', [_vm.showIndex ? _c('th', {
    staticClass: "align-center"
  }, [_c('span', [_vm._v("序号")])]) : _vm._e(), _vm._v(" "), _vm._l(_vm.columns, function (col) {
    return _c('th', {
      key: col.prop
    }, [_c('span', {
      class: _vm.getHeaderClassNames(col)
    }, [_vm._v(_vm._s(col.label))])]);
  })], 2), _vm._v(" "), _c('tbody', [!_vm.isEmpty ? _vm._l(_vm.data, function (row, rowIndex) {
    return _c('tr', {
      key: _vm.getPk(row),
      style: _vm.rowStyles
    }, [_vm.showIndex ? _c('td', {
      staticClass: "align-center"
    }, [_vm._t("index", function () {
      return [_vm._v(_vm._s(rowIndex + 1))];
    }, {
      "row": row,
      "index": rowIndex
    })], 2) : _vm._e(), _vm._v(" "), _vm._l(_vm.columns, function (col, colIndex) {
      return !!_vm.getSpan(row, col, rowIndex, colIndex)[0] && !!_vm.getSpan(row, col, rowIndex, colIndex)[1] ? _c('td', {
        key: col.prop,
        attrs: {
          "rowspan": _vm.getSpan(row, col, rowIndex, colIndex)[0],
          "colspan": _vm.getSpan(row, col, rowIndex, colIndex)[1]
        }
      }, [_c('Column', {
        attrs: {
          "column-slots": _vm.$slots,
          "row-index": rowIndex,
          "scoped-slots": _vm.$scopedSlots,
          "col": row[col.prop],
          "row": row,
          "cell-class-names": col.classNames,
          "column": col
        }
      })], 1) : _vm._e();
    })], 2);
  }) : _c('tr', {
    style: _vm.rowStyles
  }, [_c('td', {
    staticClass: "align-center",
    attrs: {
      "colspan": _vm.length + (_vm.showIndex ? 1 : 0)
    }
  }, [_vm._v("暂无数据")])])], 2)]);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-3a98397d',
  render,
  name: 'CbTable',
  components: {
    Column
  },
  props,
  computed: {
    colWidth() {
      return this.showIndex && typeof showIndex === 'object' ? this.showIndex.width : '10%';
    },
    isEmpty() {
      return !Array.isArray(this.data) || this.data.length === 0;
    },
    length() {
      return Array.isArray(this.columns) ? this.columns.length : Object.keys(this.columns).length;
    }
  },
  methods: {
    getPk(row) {
      // eslint-disable-next-line no-restricted-properties
      return row[this.pk] || Math.random() * Math.pow(10, 6).toFixed('10').replace(/\./, '');
    },
    getHeaderClassNames(column) {
      return _extends({}, this.getColumnClassNames(column), {
        cell: true,
        'no-wrap': column.noWrap !== 'wrap' || column.noWrap === undefined,
        'text-ellipse': !(column.noWrap === 'wrap' || column.noWrap === undefined)
      });
    },
    getColumnClassNames(column) {
      return {
        cell: true,
        'align-center': column.align === 'center',
        'align-left': column.align === 'left',
        'align-right': column.align === 'right',
        'no-wrap': column.noWrap !== 'wrap' || column.noWrap === undefined
      };
    }
  }
});